import { useState } from 'react';
import { toast } from 'react-toastify';
import { deleteData } from '../../../DataAccessLayer';
import { summaries } from '../../../DataAccessLayer/services';

function useDeleteSummary({ courseId, onDeleted }) {
  const [summaryToDelete, setSummaryToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const promptDelete = (summary) => setSummaryToDelete(summary);
  const cancelDelete = () => setSummaryToDelete(null);

  const deleteSummary = async () => {
    const summary = summaryToDelete;
    setIsDeleting(true);
    setSummaryToDelete(null);
    try {
      await deleteData(summaries({ id: summary.id, courseId }));
      toast.success('Summary note deleted successfully.');
      onDeleted?.(summary);
    } catch (err) {
      console.log(err);
      toast.error('Failed to delete summary note. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return { summaryToDelete, isDeleting, promptDelete, cancelDelete, deleteSummary };
}

export default useDeleteSummary;
